import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Link,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  styled,
  useTheme,
} from '@mui/material';
import Iconify from 'src/components/iconify';
import { PATH_PAGE } from 'src/routes/paths';

const NavGuide = () => {
  const theme = useTheme();

  return (
    <Box sx={{ p: 2.5, mt: 'auto' }}>
      <Link
        component={RouterLink}
        to={PATH_PAGE.guide.root}
        sx={{
          textDecoration: 'none',
          '&:hover': {
            textDecoration: 'none',
          },
        }}
      >
        <StyledListItemButton>
          <StyledListItemIcon>
            <Iconify icon="solar:notebook-bold" />
          </StyledListItemIcon>

          <ListItemText
            primary="Guide"
            sx={{
              color: theme.palette.text.light,
            }}
          />
        </StyledListItemButton>
      </Link>
    </Box>
  );
};

export default NavGuide;

const StyledListItemButton = styled(ListItemButton)({
  minHeight: 44,
  borderRadius: 0.75,
  typography: 'body2',
  color: 'text.secondary',
  textTransform: 'capitalize',
  fontWeight: 'fontWeightMedium',
});

const StyledListItemIcon = styled(ListItemIcon)({
  width: 24,
  height: 24,
  color: 'inherit',
  marginRight: 5,
});
